import isMobile from 'ismobilejs';
import windowSize from 'get-window-size';
import browser from 'browser-detect';

const userAgent = {
  state: {
    window: {
      width: windowSize().width,
      height: windowSize().height
    },
    device: {
      isPhone: isMobile.phone,
      isTablet: isMobile.tablet,
      isMobile: isMobile.any
    },
    orientation: null,
    browser: {
      name: browser().name,
      version: browser().version
    },
    screentest: false,
    isScrollLock: false,
    blockedPointerEvents: false
  },
  mutations: {
    DETECT_DEVICE(state, devices) {
      state.device = devices;
    },
    DETECT_ORIENTATION(state, payload) {
      if (payload) {
        state.orientation = 'landscape';
      } else {
        state.orientation = 'portrait';
      }
    },
    UPDATE_WINDOW_PARAMS(state, payload) {
      state.window = payload;
      state.isMobile = payload.width < 1025;
      state.device.isMobile = payload.width < 1025;
      console.log(state.device.isMobile);
    },
    UPDATE_SCREENTEST: (state, payload) => {
      state.screentest = payload;
    },
    UPDATE_LOCK_STATE: (state, payload) => {
      state.isScrollLock = payload;
    },
    BLOCK_POINTER_EVENTS: (state, payload) => {
      state.blockedPointerEvents = payload;
    }
  }
};

export default userAgent;
